import { Input, Radio, Row, Space, Form } from "antd";
import { useTranslation } from "react-i18next";

const OnePeriod = ({
    setFieldValue = () => { },
    values = {}
}) => {
    const { t, i18n } = useTranslation();

    return (
        <Row gutter={24} style={{ padding: "14px" }}>
            <Form.Item noStyle shouldUpdate>
                {({ getFieldValue }) => (
                    <Form.Item
                        name="paymentDate"
                        required
                        label={t("payroll_period.label.payment_date")}
                        labelCol={{ span: 24 }}
                        initialValue="atTheEndOfMonth"
                        rules={[{ required: true, message: i18n.language == 'th' ? `กรุณากรอก ${t("payroll_period.label.payment_date")}` : `${t("payroll_period.label.payment_date")} is required` }]}
                    >
                        <Radio.Group
                            style={{ height: "fit-content" }}
                            onChange={(e) => {
                                const { value } = e.target;
                                setFieldValue("paymentDate", value);
                            }}
                            value={getFieldValue("paymentDate")}
                            defaultValue="atTheEndOfMonth"
                        >
                            <Space direction="vertical">
                                <Radio value={"atTheEndOfMonth"}>{t("payroll_period.label.last_day")}</Radio>
                                <Radio value="everyMonth">
                                    {t("payroll_period.label.date")}
                                    <Input
                                        style={{ width: 50, marginLeft: 10, marginRight: 10 }}
                                        maxLength={2}
                                        value={values.inMonthValue}
                                        onChange={(e) => {
                                            const { value } = e.target;
                                            setFieldValue("inMonth", value);
                                        }}
                                        disabled={getFieldValue("paymentDate") !== "everyMonth"}
                                    />
                                    {t("payroll_period.label.same_month")}
                                </Radio>
                                <Radio value={"nextMonth"}>
                                    {t("payroll_period.label.date")}
                                    <Input
                                        style={{ width: 50, marginLeft: 10, marginRight: 10 }}
                                        maxLength={2}
                                        value={values.nextMonthValue}
                                        onChange={(e) => {
                                            const { value } = e.target;
                                            setFieldValue("nextMonth", value);
                                        }}
                                        disabled={getFieldValue("paymentDate") !== "nextMonth"}
                                    />
                                    {t("payroll_period.label.next_month")}
                                </Radio>
                            </Space>
                        </Radio.Group>
                    </Form.Item>
                )}
            </Form.Item>
        </Row>
    )
}

export default OnePeriod;